
import { initializeApp } from 'firebase/app';


const firebaseConfig = {
    apiKey: "AIzaSyAh9GsRLNoyz3MjrShTtpBb13wnfDRiW2g",
    authDomain: "mt-zion-14355.firebaseapp.com",
    projectId: "mt-zion-14355",
    storageBucket: "mt-zion-14355.firebasestorage.app",
    messagingSenderId: "766720097480",
    appId: "1:766720097480:web:30719777b63116e84c39fd"
  };

const app = initializeApp(firebaseConfig);
export default app;